/**
 * 视频工厂独立 Nuxt 站点公网入口（开发环境直连端口，生产环境走主域 /prompt-factory/ 反代）
 */
export function getPromptFactoryPublicUrl(): string {
  if (typeof window === 'undefined') return '/prompt-factory/'
  const host = window.location.hostname
  if (host === 'localhost' || host.includes('192.168')) {
    return `http://${host}:4002/`
  }
  return `${window.location.origin}/prompt-factory/`
}
